<template>
  <v-row justify="center">
    <v-dialog v-model="dialog" persistent scrollable width="auto">
      <v-card>
        <v-card-text>
          <h3 class="text-center">Registrar nuevo Cobro</h3>
          <v-row>
            <v-col cols="12">
              <v-combobox
                v-model="filtroestudiante"
                :items="estudiantes"
                label="* Participante"
                :loading="isloadingestudent"
                loader-height="4"
                placeholder="tecla enter para buscar..."
                prepend-inner-icon="mdi-account"
                return-object
                hide-details
                outlined
                dense
              ></v-combobox>
            </v-col>
            <v-col cols="12">
              <v-combobox
                v-model="programa"
                :items="programas"
                label="* Programa"
                :loading="isloadingprogramas"
                loader-height="4"
                prepend-inner-icon="mdi-account"
                return-object
                hide-details
                outlined
                dense
              ></v-combobox>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-combobox
                v-model="forma"
                :items="formas"
                label="* Forma de pago"
                :loading="isloadingforma"
                loader-height="4"
                prepend-inner-icon="mdi-account"
                return-object
                hide-details
                outlined
                dense
              ></v-combobox>
            </v-col>
            <v-col>
              <v-text-field v-model.trim="fecha_pago" label="* Fecha de pago" outlined dense required></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-text-field
                v-model.trim="nombre_depositante"
                label="* Nombre del depositante"
                outlined
                dense
                required
              ></v-text-field>
            </v-col>
            <v-col>
              <v-text-field
                v-model.trim="num_doc_depositante"
                label="* Documento del depositante"
                outlined
                dense
                required
              ></v-text-field>
            </v-col>
            <v-col>
              <v-combobox
                v-model="cuenta"
                :items="cuentas"
                label="* N. cuenta bancaria"
                :loading="isloadingcuentas"
                loader-height="4"
                prepend-inner-icon="mdi-account"
                return-object
                hide-details
                outlined
                dense
              ></v-combobox>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-text-field
                v-model.trim="deposito"
                label="N° Comprobante/Bancarizacion/deposito"
                outlined
                dense
                required
              ></v-text-field>
            </v-col>
          </v-row>
          <v-divider></v-divider>

          <v-row>
            <v-col>
              <v-data-table
                :headers="cabeceraplan"
                :items="plan"
                class="elevation-10"
                hide-default-footer
                disable-pagination
              >
                <template v-slot:[`item.options`]="{ item }">
                  <v-icon v-if="item.editable || item.optional" class="ma-2" color="red" @click="removeItem(item)">
                    mdi-delete-alert
                  </v-icon>
                </template>
              </v-data-table>

              <v-data-table
                :headers="cabeceraOpcionales"
                :items="opcionales"
                class="elevation-10 mt-4"
                hide-default-footer
                disable-pagination
              >
                <template v-slot:[`item.options`]="{ item }">
                  <v-icon v-if="item.editable || item.optional" class="ma-2" color="red" @click="removeItem(item)">
                    mdi-delete-alert
                  </v-icon>
                </template>
              </v-data-table>
            </v-col>

            <v-col>
              <v-data-table
                :headers="cabeceradetalles"
                :items="detalle"
                class="elevation-10"
                hide-default-footer
                disable-pagination
              >
                <template v-slot:[`item.options`]="{ item }">
                  <v-icon v-if="item.editable || item.optional" class="ma-2" color="red" @click="removeItem(item)">
                    mdi-delete-alert
                  </v-icon>
                </template>
              </v-data-table>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="dialog = false">
            Cancelar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
  import gql from 'graphql-tag';
  import xaxios from '@/xaxios';
  export default {
    components: {},
    data() {
      return {
        msg: '',
        dialog: false,
        isloadingestudent: false,
        isloadingforma: false,
        isloadingprogramas: false,
        isloadingcuentas: false,
        filtroestudiante: null,
        nombre_depositante: null,
        num_doc_depositante: null,
        deposito: null,
        forma: null,
        cuenta: null,
        fecha_pago: null,
        estudiantes: [],
        formas: [],
        cuentas: [],
        programa: null,
        programas: [],
        timeoutHnd: 0,
        cabeceraplan: [
          { text: 'Concepto', value: 'concepto' },
          { text: 'N° Cuota', value: 'numero_cuota' },
          { text: 'Monto', value: 'monto' },
          { text: 'Saldo', value: 'saldo' },
          { text: 'Fecha Pago', value: 'date_pago' },
          { text: 'Añadir', value: 'options', sortable: false, width: 40 },
        ],
        cabeceradetalles: [
          { text: 'Concepto de pago', value: 'concepto' },
          { text: 'N° Cuota', value: 'numero_cuota', width: 40 },
          { text: 'Cantidad', value: 'cantidad', width: 50 },
          { text: 'Monto', value: 'monto' },
          { text: 'Subtotal', value: 'subtotal' },
          { text: 'Un. Medida', value: 'umedida' },
          { text: 'Remover', value: 'options', sortable: false, width: 100 },
        ],
        cabeceraOpcionales: [
          { text: 'Concepto', value: 'concepto' },
          { text: 'Monto', value: 'monto' },
          { text: 'Añadir', value: 'options', sortable: false, width: 120 },
        ],
        plan: [],
        opcionales: [],
        detalle: [],
        recibo: {},
      };
    },
    computed: {},
    watch: {
      filtroestudiante: function() {
        if (!this.filtroestudiante) {
          this.filtroestudiante = '';
          //this.getDatos();
        }
        if (typeof this.filtroestudiante == 'object') {
          //this.getDatos();
          window.console.log('sele:', this.filtroestudiante);
          this.getProgramasInscritos();
          return;
        }
        if (this.timeoutHnd) {
          clearTimeout(this.timeoutHnd);
          this.timeoutHnd = 0;
        }
        var vue = this;
        this.timeoutHnd = setTimeout(function() {
          if (vue.filtroestudiante.length > 2) {
            vue.estudiantes = [];
            vue.getDatos(vue.filtroestudiante);
          } else {
            vue.msg = '';
            vue.estudiantes = [];
          }
          this.timeoutHnd = 0;
        }, 500);
      },
    },
    methods: {
      openmodal() {
        this.isloadingestudent = false;
        this.isloadingforma = false;
        this.isloadingprogramas = false;
        this.isloadingcuentas = false;
        this.filtroestudiante = null;
        this.nombre_depositante = null;
        this.num_doc_depositante = null;
        this.deposito = null;
        this.forma = null;
        this.cuenta = null;
        this.fecha_pago = null;
        this.estudiantes = [];
        this.formas = [];
        this.cuentas = [];
        this.programa = null;
        this.programas = [];
        this.timeoutHnd = 0;
        this.dialog = true;
        this.getFormasdePago();
        this.getCuentasBancarias();
      },
      getFormasdePago() {
        let vue = this;
        vue.isloadingforma = true;
        xaxios
          .get(`${process.env.VUE_APP_API_REST}/api/v1/esam/formaspagos`)
          .then(({ data }) => {
            data.data.map((x) => {
              x.text = `${x.descripcion} (${x.descripcion_SIN})`;
            });
            vue.formas = data.data;
            vue.isloadingforma = false;
          })
          .catch(function(error) {
            window.console.log(error);
            vue.isloadingforma = false;
          });
      },
      getCuentasBancarias() {
        let sede_id = this.$store.state.CARGO.sede.id;
        this.deposito = null;
        this.cuenta = null;
        this.isloadingcuentas = true;
        const sql = gql`query{getSede(id: ${sede_id}) { id, nombre, cuentasBancarias{ id, nombre, descripcion, nro, estado } ${''}}}`;
        this.$apollo.query({ query: sql }).then(({ data }) => {
          this.cuentas = data.getSede.cuentasBancarias
            ? data.getSede.cuentasBancarias.map((c_bank) => {
                // c_bank.nombre = c_bank.nombre + '  -  ' + c_bank.nro;
                c_bank.text = `${c_bank.nombre} - ${c_bank.nro}`;
                return c_bank;
              })
            : [];
          this.cuentas = this.cuentas.filter((cb) => cb.estado);
          this.isloadingcuentas = false;
        });
      },
      getDatos(query) {
        let cursor = 1000000;
        let vue = this;
        this.estudiantes = [];
        this.isloadingestudent = true;
        let isdocumento = /^\d+$/.test(+query);
        let sql = gql`query{ getPersonasByName(nombres:"${query}",cursor:${cursor}){id,num_doc,nombres,pri_apellido,seg_apellido,domicilio,telefono1,telefono2,email,usuario_moodle,clave_moodle,fecha_reg, departamento{extension} } }`;
        if (isdocumento) {
          sql = gql`query{ getPersonasByDoc(num_doc:"${query}",cursor:${cursor}){id,num_doc,nombres,pri_apellido,seg_apellido,domicilio,telefono1,telefono2,email,usuario_moodle,clave_moodle,fecha_reg, departamento{extension} } }`;
        }
        this.$apollo
          .query({ query: sql })
          .then((data) => {
            let datos = [];
            vue.isloadingestudent = false;
            if (isdocumento) datos = data.data.getPersonasByDoc;
            else datos = data.data.getPersonasByName;
            datos.map((item) => {
              if (!item.seg_apellido) item.seg_apellido = '';
              item.text = `${item.nombres} ${item.pri_apellido} ${item.seg_apellido} (doc: ${item.num_doc})`.trim();
            });
            vue.estudiantes = datos;
          })
          .catch((error) => {
            window.console.error(error);
            vue.isloadingestudent = false;
          });
      },
      getProgramasInscritos() {
        xaxios
          .get(`${process.env.VUE_APP_API_REST}/api/v1/esam/inscripcion/estudiante/id/${this.filtroestudiante.id}`)
          .then(({ data }) => {
            window.console.log(data);
          })
          .catch(function(error) {
            window.console.log(error);
          });
      },
    },
    mounted() {},
  };
</script>
<style></style>
